import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_RECENT_ACTIVITY, GET_RECENT_ACTIVITY_SUCCESS, GET_RECENT_ACTIVITY_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getRecentActivity({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/ticket-activities`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_RECENT_ACTIVITY_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_RECENT_ACTIVITY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_RECENT_ACTIVITY_ERROR, payload: error });
  }
}

export function* watchGetRecentActivity() {
  yield takeEvery(GET_RECENT_ACTIVITY, getRecentActivity);
}

function* getRecentActivitySaga() {
  yield all([fork(watchGetRecentActivity)]);
}

export default getRecentActivitySaga;